import React from 'react';
import styles from './MultipleColumnsWrapper.styl';

const MultipleColumnsWrapper: React.FunctionComponent = (props) => {
    return <div className={styles.container}>{props.children}</div>;
};

export default MultipleColumnsWrapper;
